// Sevk Adresleri penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.shippingAddresses';

export const accountShippingAddressesGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Sevk adresleri nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Bu pencere, bir cariye ait teslimat noktalarını düzenli ve güncel tutmanızı sağlar. Ekranda üstte yeni adres formu, altında adres listeleri bulunur. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve cari'),
    list: t(`${G}.regions.list`, 'Adres listeleri'),
    form: t(`${G}.regions.form`, 'Yeni sevk adresi'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Aynı cariye bağlı birden fazla teslimat adresi tutarsınız. Böylece sipariş ve sevkiyatta doğru adrese gönderim yapılır; teslimat hatası ve iade riski azalır.'),
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Adres bilgilerini girin'),
      text: t(`${G}.s2.text`, '"Yeni Sevk Adresi" formuna ülke, il, ilçe, yetkili kişi, posta kodu, telefon, cep telefonu, e-posta ve açık adresi yazın. İl ve Sevk Adresi alanları zorunludur.'),
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. "Adres Ekle" ile listeye alın'),
      text: t(`${G}.s3.text`, '"Adres Ekle" adresi henüz kaydetmez; "Eklenen Sevk Adresleri" adlı geçici listeye alır ve formu boşaltır. Böylece birkaç adresi art arda ekleyebilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Geçici listedeki bir adresi çöp kutusu simgesiyle listeden çıkarabilirsiniz.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Kayıtlı adresleri görün'),
      text: t(`${G}.s4.text`, '"Kayıtlı Sevk Adresleri" bölümü carinin daha önce kaydedilmiş adreslerini gösterir. Gerektiğinde çöp kutusu simgesiyle silebilirsiniz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kayıtlı bir adresin silinmesi hemen uygulanır, onay sorulmaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, 'Kalıcı kayıt için alttaki "Kaydet" düğmesine basın; geçici listede adres yoksa düğme pasiftir. Kaydetmeden kapatırsanız geçici listedeki adresler kaydedilmez. Sağ üstteki (i) bu rehberi yeniden açar.'),
    },
  ],
});
